import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../App.css";

import nutrition1 from "../assets/food.jpg";
import nutrition2 from "../assets/nutrition.jpg";
import nutrition3 from "../assets/nutrition1.webp";

const VerticalSwiper2 = () => {
  const images = [nutrition1, nutrition2, nutrition3, nutrition1, nutrition2, nutrition3];

  return (
    <div className="swiper-bg-container">
      <Swiper
        modules={[Autoplay]}
        direction="vertical"
        slidesPerView={3}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        className="verticalImageSwiper"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="slide-overlay-wrapper">
              <img src={img} alt={`Slide ${index + 1}`} className="vertical-image" />
              <div className="side-dark-overlay"></div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default VerticalSwiper2;
